import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col, Card, CardBody, CardTitle, CardImg } from 'reactstrap'
import { getFileIcon } from '~/lib/helpers/getFileIcon'

function CardImageTag ({ src, className }) {
  return (
    <div className={className} style={{ height: '150px', background: `url(${src}) no-repeat center center/cover` }} />
  )
}

CardImageTag.propTypes = {
  src: PropTypes.string.isRequired,
  className: PropTypes.string
}

function RelatedDocument ({ document }) {
  const {
    url,
    title,
    format
  } = document
  const icon = getFileIcon(format)

  // If no title provided, don't show that resource
  if (!title || title.length === 0) {
    return null
  }

  return (
    <Col sm='6' md='12' lg='6' className='pt-2'>
      <Card className='h-100'>
        <CardImg top src={`${url}?auto=compress&w=400&h=150&fit=crop`} tag={CardImageTag} />
        <CardBody className='border-top p-3'>
          <CardTitle className='d-flex align-items-center mb-0'>
            <i className={`pr-2 fa ${icon} fa-lg`} />
            <a href={url} target='_blank' rel='noopener noreferrer' className='stretched-link'>{title}</a>
          </CardTitle>
        </CardBody>
      </Card>
    </Col>
  )
}

RelatedDocument.propTypes = {
  document: PropTypes.object.isRequired
}

function RelatedDocuments ({ relatedDocuments }) {
  return (
    <>
      <h3>Related Documents</h3>

      <Row className='related-document-cards'>
        {relatedDocuments.map(doc => <RelatedDocument key={doc.id} document={doc} />)}
      </Row>
    </>
  )
}

RelatedDocuments.propTypes = {
  relatedDocuments: PropTypes.array.isRequired
}

export default RelatedDocuments
